import { reactive, toRefs, ref } from 'vue'
import apiAddress from '../api/address.api'

const state = reactive({
  addressList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiAddress.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useAddress() {

  const getAddressList = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiAddress.getList(params)
    state.addressList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = !params ? 20 : (params["page-size"] ? params["page-size"] : 20)

    state.loading = false
  }

  return {
    ...toRefs(state),
    getAddressList
  }
}